import { render } from "./SMSChat.vue?vue&type=template&id=363a7256&scoped=true"
import script from "./SMSChat.vue?vue&type=script&lang=js"
export * from "./SMSChat.vue?vue&type=script&lang=js"

import "./SMSChat.vue?vue&type=style&index=0&id=363a7256&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363a7256"]])

export default __exports__